// extracted by mini-css-extract-plugin
export default {"dots":"carousel-nav-pagination-component_dots__Giem5","dot":"carousel-nav-pagination-component_dot__lExka","dot-selected":"carousel-nav-pagination-component_dot-selected__7Zzi1"};